// Decisão de reuso de cache dos slices do FP, isolada para ser testável sem store.
// Os slices são por CLIENTE mas o cache guarda um `lastUpdate` só: olhar apenas a
// validade temporal devolvia o slice do cliente A para o cliente B enquanto o
// timeout de 1 min não vencia. A regra correta (já usada em apiFinancialPlanningGoals)
// é reusar só quando o clientId pedido é o MESMO que está no store.
import { diffTimeMinutes } from '@utils/Format'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'

// Cache sem cliente registrado não é "mesmo cliente", é cache vazio.
export const isSameCachedClient = (storedClientId, clientId) => {
  const hasStored = storedClientId !== null && storedClientId !== undefined
  if (!hasStored) return false
  return String(storedClientId) === String(clientId)
}

// true = devolve o cache; false = siga para a request. Só reusa com cliente
// igual E (cache fresco OU carga em voo, que vai hidratar o store de qualquer jeito).
export const shouldReuseCachedSlice = ({
  storedClientId,
  clientId,
  lastUpdate,
  loading = false,
  forceUpdate = false,
  timeoutMinutes = MINUTES_TIMEOUT_REQUESTS,
} = {}) => {
  if (!clientId) return false

  const sameClient = isSameCachedClient(storedClientId, clientId)
  if (!sameClient) return false

  // `diffTimeMinutes` responde "precisa atualizar?" — sem `lastUpdate` ele já
  // devolve true, então cache nunca preenchido cai direto para a request.
  const isFresh = !diffTimeMinutes(lastUpdate, timeoutMinutes)
  if (!forceUpdate && isFresh) return true

  return Boolean(loading)
}
